 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"2":"vendors~Routes-Accept~Routes-Counter~Routes-NewPayment~Routes-Offer~Routes-Payment~Routes-Reject~Rou~78cda7cb","3":"vendors~ArtistApp~ArtworkApp~FeatureApp~Routes-Collect~Routes-Collection~Routes-Collections~Routes-C~930d0531","4":"vendors~Routes-Accept~Routes-Counter~Routes-Reject~Routes-Respond~Routes-Review~Routes-Status","5":"vendors~ArtistApp~ArtworkApp~Routes-Collection~Routes-Overview~Routes-Works","6":"vendors~ArtistApp~ArtworkApp~Routes-Collect~Routes-Collection~Routes-Collections","7":"vendors~ArtworkApp~FeatureApp~Routes-Collect~Routes-Collection~Routes-Collections","8":"vendors~OrderApp~Routes-ConfirmBid~Routes-NewPayment~Routes-Payment~Routes-Register","9":"vendors~Routes-Accept~Routes-Counter~Routes-NewPayment~Routes-Reject~Routes-Respond","10":"vendors~Routes-ConfirmBid~Routes-NewPayment~Routes-Payment~Routes-Register~Routes-Shipping","11":"vendors~FeatureApp~Routes-Collect~Routes-Works","12":"vendors~Routes-ConfirmBid~Routes-Register","13":"vendors~Routes-Overview~Routes-Works","14":"vendors~Routes-Reject~Routes-Respond","15":"ArtworkApp","16":"IdentityVerificationApp","17":"Processing","18":"Routes-Accept","19":"Routes-Collect","20":"Routes-Collection","21":"Routes-Counter","22":"Routes-NewPayment","23":"Routes-Reject","24":"Routes-Statement-ViewingRoomStatementRoute","25":"Routes-Status","26":"Routes-Works","27":"Routes-Works-ViewingRoomWorksRoute","67":"vendors~ArtistApp","68":"vendors~Components-AuctionFAQ","69":"vendors~ConversationApp","70":"vendors~FeatureApp","71":"vendors~OrderApp","72":"vendors~Routes-Articles","73":"vendors~Routes-AuctionResults","74":"vendors~Routes-CV","75":"vendors~Routes-Collections","76":"vendors~Routes-ConfirmBid","77":"vendors~Routes-Consign","78":"vendors~Routes-Conversation","79":"vendors~Routes-Offer","80":"vendors~Routes-Overview","81":"vendors~Routes-Payment","82":"vendors~Routes-Review","83":"vendors~Routes-Shipping","84":"vendors~Routes-Shows","85":"vendors~ViewingRoomApp"}[chunkId]||chunkId) + ".22820." + {"2":"9241c59c93eb0c7fcb98","3":"0ae1256c1e69efd05360","4":"d9de2ab4a4f88f8c913e","5":"e2c74893efd5e0bf2dd8","6":"47f0b233a7f4cf38f116","7":"4fb776afac675fbb6c55","8":"29c92b45d435d825123a","9":"62f3abcd08a0718d24ac","10":"f3f9d70fb2fe3950bb04","11":"59c55ae9f4c9480b6aba","12":"40d778caa22d1cdcc0bf","13":"db9de3b0cffddac72900","14":"a4d5a6fd9af34cf7bc3d","15":"04902da0f15bab95b2d9","16":"ea068cbfc7efb53d7d31","17":"a102d83feae2c7a06927","18":"1ae7781472a67dbd6c15","19":"e13383731be674baa1b1","20":"8b922e111ee0359106e7","21":"4fb01ae2b15016e07300","22":"03da06973a5db3a3f547","23":"1fc985b230e212d186f3","24":"134615ca3daa7d8d844f","25":"79014e8412000f53f21b","26":"2228c26696a52a3e04c3","27":"30455727a9fd88a7a497","67":"66c4717bcc982449ebd2","68":"da39ac0c1d4cecf5839b","69":"52ef61a4621efa20e1d9","70":"7d4f7dfdb82772265793","71":"ae7d7c66ff55571f1815","72":"b09447ca79feb1d5299e","73":"0baba636170abfcddd17","74":"5a92951df1f79bc7f8b9","75":"a87e268149eb12b5c37c","76":"14caf5f462d60cc8f53a","77":"2e24a275619faf3230ad","78":"8c830af1e16b9eecf8f1","79":"8d3f3cac35b063153806","80":"326d31e1a50ba150700d","81":"96ba307c1b67b77bee20","82":"f3428b9864f4492a15bd","83":"d3af6ac8e5c54e4ff95c","84":"526b8970441dce23209c","85":"46352249761e1b7a99e8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				function loadScript(src, retries) {
 				  var script = document.createElement('script');
 				  var retryAttempt = 5 - retries + 1;
 				  var retryAttemptString = '&retry-attempt=' + retryAttempt;
 				  var onScriptComplete;

 				  script.charset = 'utf-8';
 				  script.timeout = 120;
 				  if (__webpack_require__.nc) {
 				    script.setAttribute('nonce', __webpack_require__.nc);
 				  }
 				  script.src = src;

 				  onScriptComplete = function(event) {
 				    // avoid mem leaks in IE.
 				    script.onerror = script.onload = null;
 				    clearTimeout(timeout);
 				    var chunk = installedChunks[chunkId];
 				    if (chunk !== 0) {
 				      if (chunk) {
 				        if (retries === 0) {
 				          var errorType =
 				            event && (event.type === 'load' ? 'missing' : event.type);
 				          var realSrc = event && event.target && event.target.src;
 				          error.message =
 				            'Loading chunk ' +
 				            chunkId +
 				            ' failed.\n(' +
 				            errorType +
 				            ': ' +
 				            realSrc +
 				            ')';
 				          error.name = 'ChunkLoadError';
 				          error.type = errorType;
 				          error.request = realSrc;
 				          chunk[1](error);
 				          installedChunks[chunkId] = undefined;
 				        } else {
 				          var cacheBust = (function() {
 				            return 'cache-bust=' + Date.now();
 				          })();
 				          +retryAttemptString;
 				          var retryScript = loadScript(
 				            jsonpScriptSrc(chunkId) + '?' + cacheBust,
 				            retries - 1
 				          );
 				          document.head.appendChild(retryScript);
 				        }
 				      } else {
 				        installedChunks[chunkId] = undefined;
 				      }
 				    }
 				  };
 				  var timeout = setTimeout(function() {
 				    onScriptComplete({ type: 'timeout', target: script });
 				  }, 120000);
 				  script.onerror = script.onload = onScriptComplete;
 				  return script;
 				}

 				var script = loadScript(jsonpScriptSrc(chunkId), 5);
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/assets/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
